import Addicon from "@mui/icons-material/Add";
import { Divider, Box, CircularProgress } from "@mui/material";
import { useMemo } from "react";

import Summary from "../components/Summary";
import useJStyles from "$hooks/useJStyles";
import JTooltip from "$components/JTooltip/JTooltip";
import { EDB_IS_DISABLED_MSG } from "../../constants";
import { useStyles } from "../styles/ProfileEDB.styles";
import ProductForm from "../../../Products/ProductForm";
import { useProfileEDBContext } from "../context/ProfileEDBContext";
import { Text, Button as LocalButton, Popin } from "$components";
import JTable from "$components/JTable/JTable";
import OrdersAndReceptions from "../../OrdersAndReceptions/OrdersAndReceptions";
import { useStyles as useEDBProfileClasses } from "$containers/EDB/styles/EdbProfile.Styles";
import OPList from "../components/OPList";

/** Convertit le format thead/bodyData legacy de useEDBProfile en colonnes/données JTable. */
function AdminInfoTable({
  tInfoHeader,
  tInfoData,
  className,
}: {
  tInfoHeader: any[];
  tInfoData: any[][];
  className?: string;
}) {
  const columns = useMemo(
    () =>
      tInfoHeader.map((col: any) => ({
        id: col.id,
        Header: col.label ?? col.id,
        Cell: ({ row }: any) => row.original[col.id],
        ...(col.minWidth ? { meta: { width: col.minWidth } } : {}),
      })),
    [tInfoHeader]
  );

  const data = useMemo(
    () =>
      tInfoData.map((row: any[]) => {
        const obj: any = {};
        tInfoHeader.forEach((col: any, i: number) => {
          obj[col.id] = row[i]?.value ?? row[i] ?? null;
        });
        return obj;
      }),
    [tInfoData, tInfoHeader]
  );

  return (
    <JTable
      data={data}
      columns={columns}
      setPageIndex={() => {}}
      hideCheckboxes
      hideFilters
      usePaper={false}
      className={className}
      rowProps={() => ({ className: "nopointer" })}
    />
  );
}

export default function AdminTab() {
  const classes = useStyles();
  const { jclasses } = useJStyles();
  const edbClasses = useEDBProfileClasses();

  const {
    edb,
    canCreateOp,
    tInfoHeader,
    tInfoData,
    integratedOrders,
    isLoading,

    // Functions
    fetchIntegratedOrders,
    handleCreateOP,
    fetchEdb,
    formOpen,
    togglePopin,
    onSubmit,
    isCreatingOp,
    isDisabled,
  } = useProfileEDBContext();

  if (isLoading || !edb) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Summary />

      <Box className={classes.iOrdersAndReceptions}>
        <OrdersAndReceptions
          fetchIntegratedOrders={fetchIntegratedOrders}
          integratedOrders={integratedOrders}
          isDisabled={isDisabled}
          edb={edb}
          fetchEdb={fetchEdb}
        />
      </Box>

      <Divider className={edbClasses.divider} />

      <div className={edbClasses.informations}>
        <div className={edbClasses.informationsHeader}>
          <Text type="h3" className={edbClasses.informationsTitle}>
            Suivi de l&apos;expression de besoin
          </Text>
          <JTooltip title={isDisabled && EDB_IS_DISABLED_MSG}>
            <LocalButton
              startIcon={<Addicon />}
              disabled={!canCreateOp}
              onClick={() => handleCreateOP()}
              style={{ marginBottom: 10 }}
            >
              {isCreatingOp ? <CircularProgress size={24} /> : "Créer les OP"}
            </LocalButton>
          </JTooltip>
        </div>
        <div className={jclasses.scrollTable}>
          <div className={jclasses.scrollTableXL}>
            <AdminInfoTable
              tInfoHeader={tInfoHeader}
              tInfoData={tInfoData}
              className={classes.products}
            />
          </div>
        </div>
      </div>

      <OPList />

      <Popin
        className={classes.CreateEdbPage_Popin}
        openPopin={formOpen}
        toggleDrawer={() => togglePopin(false)}
      >
        <Text type="h2">Produit hors catalogue</Text>
        <ProductForm
          // product={} TODO : Récupérer le produit pour le passer
          onSubmit={onSubmit}
          onReset={() => togglePopin(false)}
          company={edb?.company._id}
        />
      </Popin>
    </>
  );
}
